import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDashboardCountsContext } from '@/dashboard/provider/DashboardCountsProvider';
import {
  getIconMapper,
  noStatus,
} from '@/dashboard/components/ContributionMeta/contributionMeta.utils';

interface ContributionMetaStatusProps {
  period: string;
}

function ContributionMetaStatus({ period }: ContributionMetaStatusProps) {
  const { bandDetails, counts } = useDashboardCountsContext();

  if (!(period in bandDetails) || !(period in counts)) {
    throw new Error(`Could not find ${period} in context`);
  }

  const periodBands = bandDetails[period];
  const periodLabel = periodBands.label;
  const dateSubmitted = counts[period]?.lastSubmission;
  const iconMapper = getIconMapper(dateSubmitted);
  let status = noStatus;

  if (periodLabel === 'No records found') {
    status = iconMapper['Empty'];
  } else if (periodLabel === 'Attention required') {
    status = iconMapper['Attention'];
  } else if (periodLabel === 'Accepted') {
    status = iconMapper['Accepted'];
  } else if (periodLabel === 'Validated' || periodLabel.startsWith('Validated')) {
    status = iconMapper['Validated'];
  } else if (periodLabel === 'Rejected') {
    status = iconMapper['Rejected'];
  }

  const { icon, label, color } = status;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {icon}
      {label ? (
        <Typography variant="caption" color={color}>
          {label}
        </Typography>
      ) : null}
    </Box>
  );
}

export default ContributionMetaStatus;
